(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3952],{

/***/ 40076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76350);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var WrappedButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({}, props, {
        ref: ref
    }));
});
WrappedButton.displayName = "WrappedButton";
/* harmony default export */ __webpack_exports__["Z"] = (WrappedButton);


/***/ }),

/***/ 16312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DeliveryWizard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/index.tsx + 15 modules
var ChooseTimeAndPlace = __webpack_require__(98485);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useDeliveryWizardStep.ts
var useDeliveryWizardStep = __webpack_require__(34794);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/components/V3/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(12652);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/AddressSelector/index.tsx + 6 modules
var AddressSelector = __webpack_require__(15691);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/exportables/DeliveryWizardComponent.tsx







function DeliveryWizardComponent() {
    var ref = (0,react.useState)("choose"), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)("search"), substep = ref1[0], setSubstep = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rounded-xl py-1 shadow-md border-gray-100 bg-white dark:bg-zinc-800 dark:border-zinc-800 border-2 my-2 transition-all font-sans",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(useDeliveryWizardStep/* DeliveryWizardStepContext.Provider */.K.Provider, {
                value: {
                    setStep: setStep,
                    step: step,
                    setSubstep: setSubstep,
                    substep: substep
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-gray-100 dark:bg-zinc-700",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseTimeAndPlace/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        onClose: function() {
                            return setStep("choose");
                        },
                        isOpen: step === "create",
                        compact: true,
                        className: "dark:bg-zinc-800 font-sans",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-gray-100 dark:bg-zinc-700",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressSelector/* default */.Z, {})
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/DeliveryWizard/exportables/DeliveryWizardModal.tsx
var DeliveryWizardModal = __webpack_require__(21620);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/index.tsx


var DeliveryWizard = {
    AsModal: DeliveryWizardModal["default"],
    AsComponent: DeliveryWizardComponent
};
/* harmony default export */ var components_DeliveryWizard = (DeliveryWizard);


/***/ }),

/***/ 79989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ informativeStamps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/constants.ts
var stamps = {
    VEGAN: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FYNHhFnJ49oaeNo4bh-VEGAN.svg",
        label: "Vegano"
    },
    VEGETARIAN: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FTtMZJWqFeoM6jXZPT-VEGETARIAN.svg",
        label: "Vegetariano"
    },
    CACAO_100: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FvyL8X6C4BMa3GmGPB-COCOA_100.svg",
        label: "100% cacao"
    },
    GLUTEN_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FpAkb6dT9J5BCNdw9b-GLUTEN_FREE.svg",
        label: "Sin gluten"
    },
    LACTOSE_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FXN85u2RmNmZzZbXwm-LACTOSE_FREE.svg",
        label: "Sin lactosa"
    },
    SUGAR_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2F9tFGhk4Yeo7CGrb4p-SUGAR_FREE.svg",
        label: "Sin az\xfacar"
    },
    RECYCLABLE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FuytNnxyQ8HnKkJgqe-RECYCLABLE.svg",
        label: "Reciclable"
    },
    SPICY: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FRo6uAC2RWMGg3Tqa7-SPICY.svg",
        label: "Picante"
    },
    RECYCLED: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2Ft2xxZt5dqeK5JxWSx-RECICLED.svg",
        label: "Reciclado"
    },
    HANDMADE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FDCynECNEfDyMFAaed-HANDMADE.svg",
        label: "Hecho a mano"
    },
    OLDER_THAN_18: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FKKF3DBuShnTzrNrLz-OLDER_THAN_18.svg",
        label: "Mayor de 18"
    },
    CRUELTY_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FyNBMHBvXPe5gjraTt-CRUELTY_FREE.svg",
        label: "No testeado en animales"
    },
    KETO: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2Fv99t5FTchxQkpjgY3-KETO.svg",
        label: "Keto"
    }
};
/* harmony default export */ var constants = (stamps);

// EXTERNAL MODULE: ./src/components/InformativeStamps/styles.module.css
var styles_module = __webpack_require__(24731);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/InformativeStamps/index.tsx






function informativeStamps(param) {
    var stamps = param.stamps, iconOnly = param.iconOnly;
    if (!(stamps === null || stamps === void 0 ? void 0 : stamps.length)) return null;
    var stampsRow = stamps.map(function(stamp, index) {
        return iconOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
            content: constants[stamp].label,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).iconContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: constants[stamp].label,
                    src: constants[stamp].URL,
                    width: "16",
                    height: "16"
                }, index)
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).stampContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: constants[stamp].label,
                    src: constants[stamp].URL,
                    width: "16",
                    height: "16"
                }, index),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).label,
                    children: constants[stamp].label
                })
            ]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).rowContainer,
        children: stampsRow
    });
};


/***/ }),

/***/ 73002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PromotionTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _i18n_formatNumber_Component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18085);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32533);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56477);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function PromotionTag(param) {
    var product = param.product, _showPrice = param.showPrice, showPrice = _showPrice === void 0 ? true : _showPrice;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("website", {
        keyPrefix: "promotionType"
    }).t;
    var availabilityAt = product.availabilityAt, promotions = product.promotions;
    if (!(promotions === null || promotions === void 0 ? void 0 : promotions.length)) return null;
    if (!availabilityAt) return null;
    var finalPrice = availabilityAt.finalPrice;
    var pricing = {
        price: finalPrice,
        promotionType: promotions[0].promotionType
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_formatNumber_Component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                value: pricing.price
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().promotion),
                children: t(pricing.promotionType)
            })
        ]
    });
};


/***/ }),

/***/ 71716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ withRefetchCart; },
/* harmony export */   "H0": function() { return /* binding */ useRefetchCart; }
/* harmony export */ });
/* unused harmony export refetchCartQuery */
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _data_fragments_cartFragment_cartItemFragment_main__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90932);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCartAndPrices($websiteId: ID) {\n    preferences: userPreferences(websiteId: $websiteId) {\n      _id\n      cart {\n        items {\n          _id\n          ...resumeCartItem\n        }\n        itemsPrice\n        realPrice: itemsPrice(includeDiscount: false)\n        totalPrice\n        amountToPay\n        deliveryFee\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var refetchCartQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject(), _data_fragments_cartFragment_cartItemFragment_main__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
var useRefetchCart = function() {
    var client = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useClient */ .m8)();
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return client.query({
                        query: refetchCartQuery,
                        variables: {
                            websiteId: websiteId
                        },
                        fetchPolicy: "network-only"
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
// eslint-disable-next-line react/display-name
var withRefetchCart = function(Component) {
    return function(props) {
        var refetchCart = useRefetchCart();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, _objectSpread({}, props, {
            refetchCart: refetchCart
        }));
    };
};


/***/ }),

/***/ 98397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ setReactGA; },
/* harmony export */   "Z": function() { return /* binding */ getReactGA; }
/* harmony export */ });
var ReactGA = null;
var setReactGA = function(reactGA) {
    ReactGA = reactGA;
};
var getReactGA = function() {
    return ReactGA;
};


/***/ }),

/***/ 14726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trackPageView; }
/* harmony export */ });
/* harmony import */ var _helpers_getReactGA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98397);
/* harmony import */ var _helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55985);
/* harmony import */ var ga_4_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13241);



function trackPageView(pathname) {
    var pixel = (0,_helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    if (!pathname.includes("/virtual")) {
        pixel === null || pixel === void 0 ? void 0 : pixel.pageView();
    }
    var ReactGA = (0,_helpers_getReactGA__WEBPACK_IMPORTED_MODULE_2__/* .getReactGA */ .Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(pathname);
    if (ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isInitialized */ .ZP.isInitialized()) {
        var ga4 = ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getGA4React */ .ZP.getGA4React();
        if (ga4) {
            ga4.pageview(pathname);
        }
    }
};


/***/ }),

/***/ 55870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ECOMMERCE_EVENTS; },
  "Z": function() { return /* binding */ useTrackEcommerceEvent; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/hooks/useCookiesAccepted.ts
var useCookiesAccepted = __webpack_require__(35756);
// EXTERNAL MODULE: ./src/i18n/getCurrencyCode.ts
var getCurrencyCode = __webpack_require__(2298);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/ga-4-react/dist/ga-4-react.esm.js
var ga_4_react_esm = __webpack_require__(13241);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/sendEcommerceEventMutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation sendEcommerceEvent(\n    $eventName: String\n    $eventIdentifier: String\n    $actionSource: String\n    $orderId: ID\n    $currency: String\n    $items: [JSON]\n    $totalPrice: Float\n    $origin: String\n    $customParams: JSON\n  ) {\n    sendEcommerceEvent(\n      eventName: $eventName\n      eventIdentifier: $eventIdentifier\n      actionSource: $actionSource\n      orderId: $orderId\n      currency: $currency\n      items: $items\n      totalPrice: $totalPrice\n      origin: $origin\n      customParams: $customParams\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var sendEcommerceEventMutation = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/helpers/getReactGA.ts
var getReactGA = __webpack_require__(98397);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/helpers/getReactPixel.ts
var getReactPixel = __webpack_require__(55985);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/index.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var providers = {
    GA4: "ga4",
    PIXEL: "pixel",
    GTM: "gtm"
};
var pixelSendEvent = function(eventName, data, eventExtraData) {
    var reactPixel = (0,getReactPixel/* default */.Z)();
    reactPixel === null || reactPixel === void 0 ? void 0 : reactPixel.fbq("track", eventName, data, eventExtraData);
};
var recommendedEvents = {
    ADD_TO_CART: {
        pixel: "AddToCart",
        ga4: "add_to_cart",
        gtm: "add_to_cart"
    },
    BEGIN_CHECKOUT: {
        pixel: "InitiateCheckout",
        ga4: "begin_checkout",
        gtm: "begin_checkout"
    },
    PURCHASE: {
        pixel: "Purchase",
        ga4: "purchase",
        gtm: "purchase"
    },
    SELECT_ITEM: {
        ga4: "select_item",
        gtm: "select_item"
    }
};
var ga4SendEvent = function(action, additionalData) {
    var custom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, label = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, category = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, nonInteraction = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if ((0,isServerSide/* default */.Z)()) return;
    var isInitialized = ga_4_react_esm/* default.isInitialized */.ZP.isInitialized();
    if (!isInitialized) {
        return;
    }
    var ga4 = ga_4_react_esm/* default.getGA4React */.ZP.getGA4React();
    if (!ga4) {
        logger/* default.warn */.Z.warn("Could not get GA4React");
        return;
    }
    var data = _objectSpread({}, additionalData);
    if (custom) {
        data = _objectSpread({}, data, {
            event_label: label,
            event_category: category,
            nonInteraction: nonInteraction
        });
    }
    ga4.gtag("event", action, data);
};
var gtmSendEvent = function(dataLayer) {
    dist_default().dataLayer({
        dataLayer: dataLayer
    });
};
var analyticsEventManager = {
    pixel: pixelSendEvent,
    ga4: ga4SendEvent,
    gtm: gtmSendEvent
};

// EXTERNAL MODULE: ./src/helpers/track/trackPageView.ts
var trackPageView = __webpack_require__(14726);
;// CONCATENATED MODULE: ./src/helpers/track/trackAddToCart.ts




function trackAddToCart(param, param1) {
    var product = param.product, item = param.item, amount = param.amount, eventId = param1.eventId;
    if (!product || !item) return;
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    var currency = (0,getCurrencyCode/* default */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currency
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addProduct", {
        id: product._id,
        name: product.name,
        price: item.unitPrice,
        category: product.categories.length ? product.categories[0].internalName : null,
        quantity: amount,
        currency: currency
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "add");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.event({
        category: "UX",
        action: "addProductToCart",
        label: "Agregar al carro"
    });
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id,
        value: item.unitPrice,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.ADD_TO_CART.pixel, pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: item.unitPrice,
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                price: item.unitPrice,
                quantity: amount
            }
        ]
    };
    analyticga4SendEvent(recommendedEvents.ADD_TO_CART.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.ADD_TO_CART.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name,
                    price: item.unitPrice,
                    quantity: amount
                }
            ]
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/add_to_cart");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackInitCheckout.ts



function trackInitCheckout(param, param1) {
    var cart = param.cart, eventId = param1.eventId;
    if (!cart) return;
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "checkout");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview("/checkout");
    var currency = (0,getCurrencyCode/* default */.Z)();
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var numItems = cart.items.reduce(function(sum, item) {
        return item.amount + sum;
    }, 0);
    var pixelData = {
        value: cart.itemsPrice,
        num_items: numItems,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.BEGIN_CHECKOUT.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(cart.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: cart.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.BEGIN_CHECKOUT.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.BEGIN_CHECKOUT.gtm,
        ecommerce: {
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
};

;// CONCATENATED MODULE: ./src/helpers/track/trackProductView.ts
function trackProductView_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function trackProductView_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            trackProductView_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function trackProductView(param, param1) {
    var product = param.product, eventId = param1.eventId;
    if (!product) return;
    if (!product.availabilityAt) return;
    var finalPrice = product.availabilityAt.finalPrice;
    var currencyCode = (0,getCurrencyCode/* default */.Z)();
    var gaData = {
        id: product._id,
        name: product.name,
        category: product.categories.length ? product.categories[0].internalName : null
    };
    var ga4Data = {
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                category: product.categories.length ? product.categories[0].internalName : null,
                currency: currencyCode
            }
        ]
    };
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id
    };
    var gtmData = {
        event: recommendedEvents.SELECT_ITEM.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name
                }
            ]
        }
    };
    if (finalPrice) {
        pixelData = trackProductView_objectSpread({}, pixelData, {
            value: finalPrice,
            currency: currencyCode
        });
        ga4Data["items"] = [
            trackProductView_objectSpread({}, ga4Data["items"][0], {
                price: finalPrice
            })
        ];
        gtmData["ecommerce"]["items"] = [
            trackProductView_objectSpread({}, gtmData["ecommerce"]["items"][0], {
                price: finalPrice
            })
        ];
        gaData = trackProductView_objectSpread({}, gaData, {
            price: finalPrice
        });
    }
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currencyCode
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addImpression", gaData);
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "detail");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    analyticPixelSendEvent("ViewContent", pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    analyticga4SendEvent(recommendedEvents.SELECT_ITEM.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/view_content");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackPurchase.ts




function trackPurchase(param, param1) {
    var order = param.order, eventId = param1.eventId;
    if (!order) return;
    var currency = (0,getCurrencyCode/* default */.Z)();
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "clear", {});
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currency
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = order.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addProduct", {
                id: item.product._id,
                name: item.product.name,
                category: item.product.categories.length ? item.product.categories[0].internalName : null,
                price: item.unitPrice,
                quantity: item.amount
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "purchase", {
        id: order._id,
        revenue: order.totalPrice,
        coupon: order.couponCode,
        shipping: order.deliveryFee
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        value: order.totalPrice,
        num_items: order.totalItems,
        currency: currency,
        content_type: "product",
        content_ids: Array.from(order.items.map(function(item) {
            return item.product._id;
        }))
    };
    analyticPixelSendEvent(recommendedEvents.PURCHASE.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(order.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            item_category: item.product.categories.length ? item.product.categories[0].internalName : null,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        transaction_id: order._id,
        value: order.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.PURCHASE.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.PURCHASE.gtm,
        ecommerce: {
            currency: currency,
            transaction_id: order._id,
            value: order.totalPrice,
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/purchase");
};

;// CONCATENATED MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useTrackEcommerceEvent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useTrackEcommerceEvent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useTrackEcommerceEvent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var ECOMMERCE_EVENTS;
(function(ECOMMERCE_EVENTS) {
    ECOMMERCE_EVENTS["PAGEVIEW"] = "PageView";
    ECOMMERCE_EVENTS["VIEWCONTENT"] = "ViewContent";
    ECOMMERCE_EVENTS["INITCHECKOUT"] = "InitiateCheckout";
    ECOMMERCE_EVENTS["ADDTOCART"] = "AddToCart";
    ECOMMERCE_EVENTS["PURCHASE"] = "Purchase";
})(ECOMMERCE_EVENTS || (ECOMMERCE_EVENTS = {}));
function gtag(ga4, method, ga4Code, value) {
    return _gtag.apply(this, arguments);
}
function _gtag() {
    _gtag = _asyncToGenerator(runtime_default().mark(function _callee(ga4, method, ga4Code, value) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        ga4.gtag(method, ga4Code, value, function(result) {
                            resolve(result);
                        });
                        setTimeout(function() {
                            reject("timeout");
                        }, 1000);
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _gtag.apply(this, arguments);
}
function customParamsToEvent(initialData) {
    return _customParamsToEvent.apply(this, arguments);
}
function _customParamsToEvent() {
    _customParamsToEvent = /**
 * Based on the data required for GA4 Measurement protocol https://developers.google.com/analytics/devguides/collection/protocol/ga4?hl=es
 * @param initialData
 * @returns {Promise<{clientId: string, sessionId: string}>}
 */ _asyncToGenerator(runtime_default().mark(function _callee(initialData) {
        var ref, ref1, customParams, ga4Code, ga4, clientId, sessionId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    customParams = {};
                    ga4Code = (ref = initialData.integrations) === null || ref === void 0 ? void 0 : (ref1 = ref.integrations) === null || ref1 === void 0 ? void 0 : ref1.googleAnalyticsV4Id;
                    if (!(ga4Code && ga_4_react_esm/* default.isInitialized */.ZP.isInitialized())) {
                        _ctx.next = 15;
                        break;
                    }
                    ga4 = ga_4_react_esm/* default.getGA4React */.ZP.getGA4React();
                    if (ga4) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", customParams);
                case 7:
                    _ctx.next = 9;
                    return gtag(ga4, "get", ga4Code, "client_id");
                case 9:
                    clientId = _ctx.sent;
                    customParams["clientId"] = clientId;
                    _ctx.next = 13;
                    return gtag(ga4, "get", ga4Code, "session_id");
                case 13:
                    sessionId = _ctx.sent;
                    customParams["sessionId"] = sessionId;
                case 15:
                    return _ctx.abrupt("return", customParams);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _customParamsToEvent.apply(this, arguments);
}
function serverSendEvent(eventName, mutate, data, initialData) {
    return _serverSendEvent.apply(this, arguments);
}
function _serverSendEvent() {
    _serverSendEvent = _asyncToGenerator(runtime_default().mark(function _callee(eventName, mutate, data, initialData) {
        var orderId, eventId, source, items, currency, totalPrice, variables, customParams;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (mutate) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    orderId = data.orderId, eventId = data.eventId, source = data.source, items = data.items, currency = data.currency, totalPrice = data.totalPrice;
                    variables = useTrackEcommerceEvent_objectSpread({
                        eventName: eventName,
                        eventIdentifier: eventId,
                        currency: currency,
                        totalPrice: totalPrice,
                        actionSource: source,
                        origin: "web"
                    }, items && {
                        items: items
                    }, orderId && {
                        orderId: orderId
                    });
                    _ctx.next = 7;
                    return customParamsToEvent(initialData);
                case 7:
                    customParams = _ctx.sent;
                    variables["customParams"] = customParams;
                    _ctx.next = 11;
                    return mutate({
                        mutation: sendEcommerceEventMutation,
                        variables: variables
                    });
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    logger/* default.warn */.Z.warn("could not send event to ecommerceEvents", {
                        error: _ctx.t0
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _serverSendEvent.apply(this, arguments);
}
function useTrackEcommerceEvent() {
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var initialData = (0,useInitialData/* default */.Z)();
    var cookies = (0,useCookiesAccepted/* default */.Z)();
    var trackEcommerceEvent = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event1, params1) {
            var getEventServerData, serverData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getEventServerData = function _getEventServerData(event, params) {
                            var eventId = (0,v4/* default */.Z)();
                            var currency = (0,getCurrencyCode/* default */.Z)();
                            var baseData = {
                                currency: currency,
                                eventId: eventId,
                                source: location.origin
                            };
                            if (event === ECOMMERCE_EVENTS.PAGEVIEW) {
                                if (cookies) (0,trackPageView/* default */.Z)(params);
                                return null;
                            }
                            if (event === ECOMMERCE_EVENTS.VIEWCONTENT) {
                                if (cookies) trackProductView(params, {
                                    eventId: eventId
                                });
                                var product = params.product;
                                if (!product) return null;
                                var items = [
                                    {
                                        id: product._id,
                                        quantity: 1,
                                        itemPrice: product.value,
                                        itemName: product.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items,
                                    totalPrice: product.value
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.INITCHECKOUT) {
                                if (cookies) trackInitCheckout(params, {
                                    eventId: eventId
                                });
                                var cart = params.cart;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: Array.from(cart.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    })),
                                    totalPrice: cart.itemsPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.ADDTOCART) {
                                if (cookies) trackAddToCart(params, {
                                    eventId: eventId
                                });
                                var product1 = params.product, amount = params.amount, item1 = params.item;
                                if (!product1) return null;
                                var items1 = [
                                    {
                                        id: product1._id,
                                        quantity: amount,
                                        itemPrice: item1.unitPrice,
                                        itemName: product1.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items1,
                                    totalPrice: item1.totalPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.PURCHASE) {
                                if (cookies) trackPurchase(params, {
                                    eventId: eventId
                                });
                                var order = params.order;
                                if (!order) return null;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    orderId: order._id,
                                    totalPrice: order.totalPrice
                                }, order.items && {
                                    items: Array.from(order.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    }))
                                });
                            }
                            return null;
                        };
                        _ctx.prev = 1;
                        ;
                        serverData = getEventServerData(event1, params1);
                        if (serverData) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return serverSendEvent(event1, mutate, serverData, initialData);
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        logger/* default.warn */.Z.warn("error useTrackEcommerceEvent", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function trackEcommerceEvent(event1, params1) {
            return _ref.apply(this, arguments);
        };
    }();
    return trackEcommerceEvent;
};


/***/ }),

/***/ 10467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCheckoutVersion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _providers_CheckoutVersionContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53957);


function useCheckoutVersion() {
    var version = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_CheckoutVersionContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return version;
};


/***/ }),

/***/ 18085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormatNumber; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62832);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78263);




/**
 * Formats the number as a currency using the locale of the current website obtained through the initialData context.
 */ function FormatNumber(param) {
    var value = param.value, _format = param.format, format = _format === void 0 ? "money" : _format, localeParam = param.locale, render = param.render, _removeSymbolPreffix = param.removeSymbolPreffix, removeSymbolPreffix = _removeSymbolPreffix === void 0 ? false : _removeSymbolPreffix;
    var initialData = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var locale = localeParam !== null && localeParam !== void 0 ? localeParam : initialData.website.country.locale;
    var number = (0,_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(value, format, locale, removeSymbolPreffix);
    if (render) {
        return render(number);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: number
    });
};


/***/ }),

/***/ 66767:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    es_CL: "CLP",
    es_MX: "MXN",
    es_PE: "PEN",
    es_CO: "COP",
    en_US: "USD",
    es_EC: "USD",
    es_CR: "CRC",
    es_AR: "ARS"
});


/***/ }),

/***/ 78263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formatNumber; }
});

// EXTERNAL MODULE: ./src/i18n/formatNumber/registerLocales.ts + 1 modules
var registerLocales = __webpack_require__(66385);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/i18n/formatNumber/currencyCodes.ts
var currencyCodes = __webpack_require__(66767);
;// CONCATENATED MODULE: ./src/i18n/formatNumber/moneyFormats.ts
/* harmony default export */ var moneyFormats = ({
    es_CL: "$0,0.[00]",
    es_MX: "$0,0.00",
    es_PE: "$0,0.00",
    es_CO: "$0,0.[00]",
    en_US: "$0,0.00",
    es_EC: "$0,0.00",
    es_CR: "$0,0.[00]",
    es_AR: "$0,0.[00]"
});

;// CONCATENATED MODULE: ./src/i18n/formatNumber/index.ts




function formatNumber(number, format, locale, removeSymbolPreffix) {
    locale = locale || __webpack_require__.g.currentLocale || "es_CL";
    (0,registerLocales/* default */.Z)(locale ? [
        locale
    ] : []);
    var numeralFormat = format;
    if (format === "money" || format === "moneyCode") {
        numeralFormat = moneyFormats[locale] || moneyFormats.es_CL;
    }
    if (numeralFormat === "0,0%") {
        numeralFormat = "0,0.[00]%";
    }
    var prevLocale = (numeral_default()).options.currentLocale;
    if (prevLocale !== locale) {
        numeral_default().locale(locale);
    }
    var numeralFormatCurrency = removeSymbolPreffix ? numeralFormat.replace("$", "") : numeralFormat;
    var result = numeral_default()(number).format(numeralFormatCurrency);
    if (prevLocale !== locale) {
        numeral_default().locale(prevLocale);
    }
    if (format === "moneyCode") {
        return "".concat(result, " ").concat(currencyCodes/* default */.Z[locale]);
    } else {
        return result;
    }
};


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GetCurrencyCode; }
/* harmony export */ });
/* harmony import */ var _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66767);

function GetCurrencyCode() {
    var locale = __webpack_require__.g.currentLocale || "es_CL";
    return _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[locale];
};


/***/ }),

/***/ 80885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAdd; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/fireEvent.js
var fireEvent = __webpack_require__(93415);
// EXTERNAL MODULE: ./src/data/queries/preferences/refetchCart.tsx
var preferences_refetchCart = __webpack_require__(71716);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts + 6 modules
var useTrackEcommerceEvent = __webpack_require__(55870);
// EXTERNAL MODULE: ./src/hooks/useCheckoutVersion.ts
var useCheckoutVersion = __webpack_require__(10467);
// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./src/page-components/Order/CartLoadingContext.tsx
var CartLoadingContext = __webpack_require__(10177);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/mutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation addProductToCart(\n    $productId: ID\n    $amount: Float\n    $modifiers: [CartItemOptionInput]\n    $comment: String\n    $menuId: ID\n  ) {\n    item: addProductToCart(\n      productId: $productId\n      amount: $amount\n      modifiers: $modifiers\n      comment: $comment\n      menuId: $menuId\n    ) {\n      _id\n      totalPrice(includeDiscount: true)\n      unitPrice\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutation = ((0,lib["default"])(_templateObject()));

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/mutationEdit.ts
function mutationEdit_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mutationEdit_templateObject() {
    var data = mutationEdit_taggedTemplateLiteral([
        "\n  mutation updateCartItem(\n    $productId: ID\n    $amount: Float\n    $modifiers: [CartItemOptionInput]\n    $comment: String\n    $menuId: ID\n    $cartItemId: ID\n  ) {\n    item: updateCartItem(\n      cartItemId: $cartItemId\n      productId: $productId\n      amount: $amount\n      modifiers: $modifiers\n      comment: $comment\n      menuId: $menuId\n    ) {\n      _id\n      totalPrice(includeDiscount: true)\n      unitPrice\n    }\n  }\n"
    ]);
    mutationEdit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutationEdit = ((0,lib["default"])(mutationEdit_templateObject()));

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













function useAdd() {
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var showMessage = (0,useMessage/* default */.Z)();
    var trackEcommerceEvent = (0,useTrackEcommerceEvent/* default */.Z)();
    var checkoutVersion = (0,useCheckoutVersion/* default */.Z)();
    var ref10 = (0,CartLoadingContext/* useCartLoading */.k6)(), setCartLoading = ref10.setLoading;
    var refetchCart = (0,preferences_refetchCart/* useRefetchCart */.H0)();
    var baseEventsProperties = (0,useEventsBaseProperties/* default */.Z)();
    // TODO (Important): Refactor and set types
    return function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(props, state, product, resume) {
            var opts, setLoadingOpts, keepLoadingOnFinish, setLoading, success, variables, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, item, _modifiers, modifiers, requiredModifiers, ref8, ref9, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        opts = _args.length > 4 && _args[4] !== void 0 ? _args[4] : {};
                        setLoadingOpts = opts.setLoading, keepLoadingOnFinish = opts.keepLoadingOnFinish;
                        setLoading = function(loading) {
                            if (setLoadingOpts) setLoadingOpts(loading);
                            setCartLoading(loading);
                        };
                        success = false;
                        if (!resume.missingModifier) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,fireEvent["default"])("scrollToRequiredModifier", resume.missingModifier);
                        return _ctx.abrupt("return");
                    case 7:
                        setLoading(true);
                        _ctx.prev = 8;
                        variables = {
                            productId: props.product._id,
                            amount: state.amount,
                            modifiers: state.modifiers,
                            comment: state.comment,
                            menuId: props.menuId
                        };
                        if (!props.cartItem) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 13;
                        return mutate({
                            mutation: mutationEdit,
                            variables: _objectSpread({
                                cartItemId: props.cartItem._id
                            }, variables)
                        });
                    case 13:
                        _ctx.next = 27;
                        break;
                    case 15:
                        ;
                        _ctx.next = 18;
                        return mutate({
                            mutation: mutation,
                            variables: variables
                        });
                    case 18:
                        item = _ctx.sent.item;
                        _ctx.next = 21;
                        return refetchCart();
                    case 21:
                        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.ADDTOCART */.X.ADDTOCART, {
                            product: product,
                            item: item,
                            amount: state.amount
                        });
                        ;
                        modifiers = (_modifiers = product.modifiers) !== null && _modifiers !== void 0 ? _modifiers : [];
                        requiredModifiers = modifiers.filter(function(modifier) {
                            return modifier.optional;
                        });
                        ;
                        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productAdded */.F.purchase.productAdded, _objectSpread({
                            categoryId: ((ref = product.categories) === null || ref === void 0 ? void 0 : ref.length) ? product.categories[0]._id : "",
                            categoryName: ((ref1 = product.categories) === null || ref1 === void 0 ? void 0 : ref1.length) ? product.categories[0].name : "",
                            productName: product.name,
                            productId: (ref2 = props.product) === null || ref2 === void 0 ? void 0 : ref2._id,
                            productDescription: product.description,
                            productAmount: state.amount,
                            fullPrice: (ref3 = product.availabilityAt) === null || ref3 === void 0 ? void 0 : ref3.basePrice,
                            productDiscount: (ref8 = ((ref4 = product.availabilityAt) === null || ref4 === void 0 ? void 0 : ref4.basePrice) - ((ref5 = product.availabilityAt) === null || ref5 === void 0 ? void 0 : ref5.finalPrice)) !== null && ref8 !== void 0 ? ref8 : 0,
                            productTotalPrice: ((ref9 = (ref6 = product.availabilityAt) === null || ref6 === void 0 ? void 0 : ref6.finalPrice) !== null && ref9 !== void 0 ? ref9 : 0) * state.amount,
                            amountRequiredModifiers: requiredModifiers.length,
                            amountOptionalModifiers: modifiers.length - requiredModifiers.length,
                            selectedOptionalModifiers: ((ref7 = state.modifiers) === null || ref7 === void 0 ? void 0 : ref7.length) - requiredModifiers.length,
                            actionLocation: checkoutVersion,
                            menuId: props.menuId
                        }, baseEventsProperties));
                    case 27:
                        if (props.onAdd) {
                            props.onAdd();
                        }
                        props.close();
                        success = true;
                        _ctx.next = 35;
                        break;
                    case 32:
                        _ctx.prev = 32;
                        _ctx.t0 = _ctx["catch"](8);
                        showMessage(_ctx.t0);
                    case 35:
                        setCartLoading(false);
                        // In some cases, we want to keep showing the loading state until the location changes
                        if (success && !keepLoadingOnFinish) setLoading(false);
                    case 37:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    32
                ]
            ]);
        }));
        return function(props, state, product, resume) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 53957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("v2"));


/***/ }),

/***/ 24731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"_1FBOTCTDk1tpvN0CWtJEGO","stampContainer":"_2dHjoWB7y4fjNlK-GGZIHV","informativeStampsContainer":"TLYGzXDnclJIHO_eFXkgD","label":"_3tC3I5ZkO3-9aTewxfaeGV","rowContainer":"hKVbLQovEQ4cRYH4PIDae"};

/***/ }),

/***/ 56477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_3fjtgEVPfQMdW4VsJNRfCh"};

/***/ })

}]);